import { GridLayoutColumn } from './grid-layout-column';

export class GridLayout {
  id!: string;
  name!: string;
  isSelected!: boolean;
  columns!: GridLayoutColumn[];
}
